import FullServiceCustomer from './FullServiceCustomer'
export class FullServicePricingInfo {
    RequestID: number;
    ZQCustomerNumber?: string;
    ZQCustomerName?: string;
    ZQCustomerSalesOfficeID?: number;
    EffectiveDate?: Date;
    NeedsReview?: boolean;
    
}

export default FullServicePricingInfo;